import { FC } from 'react';
import { Spin } from 'antd';
import { FormItemProps } from 'antd/lib/form';
import { SelectProps } from 'antd/lib/select';
import { useField } from 'formik';
import { SelectField } from '@shared/modules/form/fields/select';
import { USER_SEARCH_MIN_LENGTH, useUserSelectSearch } from '../hooks';

export type UserSelectFieldProps = {
  name: string;
  item?: FormItemProps;
  input?: SelectProps<any>;
  /** Əlavə server filtrləri, məs. `{ admin: 1 }`. */
  query?: Record<string, any>;
  enabled?: boolean;
  /** Server filtri siyahını kiçik saxlayırsa açın — siyahı yazmadan da görünür. */
  preload?: boolean;
};

/**
 * Bütün müştəri bazası üzərində istifadəçi seçimi üçün sahə: siyahını əvvəlcədən
 * yükləmir, yazılan mətni serverə göndərib yalnız uyğun gələnləri gətirir.
 */
export const UserSelectField: FC<UserSelectFieldProps> = ({ name, item, input, query, enabled, preload }) => {
  const [{ value }] = useField(name);
  const users = useUserSelectSearch({ selected: value, query, enabled, preload });

  const notFoundContent = users.isLoading ? (
    <Spin size="small" style={{ display: 'block', padding: '8px 0' }} />
  ) : (
    <span>{users.isSearchable || users.hasOptionsWithoutSearch ? 'İstifadəçi tapılmadı' : `Ad, soyad və ya ID üzrə ən azı ${USER_SEARCH_MIN_LENGTH} simvol daxil edin`}</span>
  );

  return (
    <SelectField
      name={name}
      item={item}
      input={{
        placeholder: 'Ad, soyad və ya ID ilə axtarın...',
        ...input,
        showSearch: true,
        filterOption: false,
        onSearch: users.setSearch,
        options: users.options,
        loading: users.isLoading,
        notFoundContent,
      }}
    />
  );
};
